import React, { useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import deburr from "lodash/deburr";
import Autosuggest from "react-autosuggest";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Popper from "@material-ui/core/Popper";
import { withStyles } from "@material-ui/core/styles";
import { saProjectFetchList, saProjectQueryParams } from "./SACreateActions";

const suggestions = [];

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: (node) => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.ProjectID, query);
  const parts = parse(suggestion.ProjectID, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) =>
          part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          )
        )}
      </div>
    </MenuItem>
  );
}

function getSuggestions(value) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : suggestions.filter((suggestion) => {
        const keep =
          count < 5 &&
          suggestion.ProjectID.slice(0, inputLength).toLowerCase() ===
            inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

function getSuggestionValue(suggestion) {
  return suggestion.ProjectID;
}

const styles = (theme) => ({
  root: {
    // height: 250,
    width: "100%",
    flexGrow: 1,
  },
  container: {
    position: "relative",
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

class ProjectAutoComplete extends React.Component {
  state = {
    single: "",
    popper: "",
    suggestions: [],
    inError: false,
  };

  componentDidUpdate(prevProps, prevState) {
    // console.log("...this.props", this.props);

    // if a valid proj that matches is typed in full, it will be auto selected
    if (this.props.projectSuggestions !== prevProps.projectSuggestions) {
      if(this.state.single.length == 8 && this.props.projectSuggestions.length == 1){
        this.props.selectionCallback(this.props.projectSuggestions[0]);
      }
      else if(this.state.single.length == 8 && this.props.projectSuggestions.length == 0){
        this.props.completedCallback(this.state.single);
      }
      // else if (this.state.single.length<8 && ){}
      this.setState({
        suggestions: this.props.projectSuggestions,
      });
    }
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    // console.log("...handleSuggestionsFetchRequested", value)

    this.props.setQueryParams({
      page: 1,
      pageSize: 10,
      partialProjectID: value,
    });

    this.setState({
      suggestions: getSuggestions(value),
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handleChange = (name) => (event, { newValue }) => {
    // console.log("....newValue",newValue)
    // console.log("....event",event.target)
    // let currentSuggestions = 0;
    // if(this.props.projectSuggestions)
    //   currentSuggestions = this.props.projectSuggestions.length;...FUK current suggestions isnt updated here!!!

    if (newValue.length < 8) {
      this.props.incompleteCallback(newValue);
    }

    //     if(newValue.length == 8){
    //       this.props.completedCallback();
    // // can probably replace the componentDidUpdate stuff with this.componentDidCatch.apply. but also dismiss the popup
    //     }

    // if (newValue.length == 8 && currentSuggestions == 1) {
    //   this.props.selectionCallback(this.props.projectSuggestions[0]);
    // }
    // else if(newValue.length == 8 && currentSuggestions == 0){
    //   this.props.completedCallback(newValue, currentSuggestions);
    // }

    const input = newValue;
    const acceptedInput = /^[0-9]{0,8}$/;
    if (acceptedInput.test(input) || input === "") {
      this.setState({
        [name]: newValue,
        inError: false,
      });
    } else {
      this.setState({
        inError: true,
      });
    }

    // this.setState({
    //   [name]: newValue,
    // });
  };

  onSuggestionSelected = (event, obj) => {
    // console.log("...selectedSuggestion",obj.suggestion);
    // this.props.setSelectedProject(obj.suggestion);
    console.log("...", this.state);
    this.props.selectionCallback(obj.suggestion);
  };

  render() {
    const { classes } = this.props;

    const autosuggestProps = {
      renderInputComponent,
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue,
      renderSuggestion,
      onSuggestionSelected: this.onSuggestionSelected,
    };

    return (
      <div className={classes.root}>
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            classes,
            label: "Project Number",
            value: this.state.single,
            helperText: "An <8 digit> project number",
            error: this.state.inError,
            onChange: this.handleChange("single"),
            // onInputChange: this.setState()
          }}
          theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={(options) => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
        />
      </div>
    );
  }
}

ProjectAutoComplete.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  token: state.token,
  projectSuggestions: state.saProjects,
  // suggestions: state.saProjects ||
});

const mapDispatchToProps = (dispatch) => {
  return {
    setQueryParams: (payload) => {
      dispatch(saProjectQueryParams(payload));
      dispatch(saProjectFetchList());
    },
    // setSelectedProject: payload => dispatch(saSelectedProject(payload)),
  };
};

// export default withStyles(styles)(ProjectAutoComplete);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProjectAutoComplete));
